import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {  Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PluginService, AlertService } from '../../../services';
import { ProductService, LookupService } from '../../../services/models';
import { BaseEditComponent } from '../../base/base.edit.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PublishDialogComponent } from '../publishdialog/publish-dialog.component';


@Component({
    templateUrl: './products.edit.component.html',
    styleUrls: ['./products.edit.component.less'], 
    selector: 'products-edit'
})

export class  ProductsEditComponent extends BaseEditComponent implements OnInit {

    productForm: FormGroup;
    record: any = null;
    categories: any = [];
    zones:any = [];
    draftProducts: any = {};
    products_lookup_endpoint: string = "products";
    @Input() id: any = null;
    @Output() close = new EventEmitter();

    constructor(
        private router: Router,
        private productService: ProductService,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private lookupService: LookupService,
        protected pluginService: PluginService,
        protected alertService: AlertService,
        public dialog: MatDialog,
    ) {
        super(pluginService);
    }

    ngOnInit() {
        this.productForm = this.formBuilder.group({
            name: ['', Validators.required],
            short_name: [''],
            slug: ['', Validators.compose([Validators.required])],
            category_id: ['', Validators.required],
            tag_line: [''],
            subcategory_id: [''],
            subcategory2_id: [''],
            consumer_calc : ['1'],
            dealer_calc : ['1'],
            points: [''],
            order: [''],
            enabled: [''],
            discontinued: [''],
            recall: ['0'],
            featured: [''],
            blurb: [''],
            description: [''],
            meta_title: [''],
            meta_description: [''],
            meta_image: [''],
            assist_meta_title: [''],
            assist_meta_description: [''],
            assist_meta_image: [''],
            main_image_url: [''],
            list_image_url: [''],
            main_video_url: [''],
            main_video_id: [''],
            related_products: [],
            zone: [''],
            warranty_able: [''],
            salesforce_id: [''],
            recall_header: [''],
            recall_button_text: [''],
            recall_button_url: [''],
        });

        this.lookupService.getAll("categories")
            .subscribe(
                data => {
                    this.categories = data.data;
                },
                error => {
                    this.handleError(error, this.productForm);
                });

        this.lookupService.getAll("zones")
            .subscribe(
                data => {
                    this.zones = data.data;
                },
                error => {
                    this.handleError(error, this.productForm);
                });

        if (this.id != 'new') {
            this.productService.getRecord(this.id)
                .subscribe(
                    data => {
                        this.record = data.data;
                        this.draftProducts = this.record.draft_products;
                    },
                    error => {
                        this.handleError(error, this.productForm);
                    });
        } else {
            this.record = {
                "related_products": {"data": []}
            };
        }

    }

    draftsLookup(draftid: any){
        this.id = draftid;
        this.record.id = draftid;
        this.productService.getRecord(draftid)
        .subscribe(
            data => {
                this.record = data.data;
                this.record.id = data.data.id;
                this.draftProducts = this.record.draft_products;
            },
            error => {
                this.handleError(error, this.productForm);
        });
    }

    cancel() {
        this.close.emit();
    }

    save() {
        let product_ids =  this.record.related_products;
    
        this.record = this.productForm.value;
        this.record.id = this.id;

        this.record.related_products = product_ids;

        if (this.id != 'new') {
            this.productService.save(this.record)
            .subscribe(
                data => {
                    this.id = data.data.id;
                    this.record = data.data;
                    this.draftProducts = data.data.draft_products;
                    this.draftsLookup(this.id);
                },
                error => {
                    this.handleError(error, this.productForm);
                });
        } else {
            this.productService.create(this.record)
            .subscribe(
                data => {
                    this.id = data.data.id;
                    this.record = data.data;
                    this.router.navigate(['/products/' + data.data.id]);
                },
                error => {
                    this.handleError(error, this.productForm);
                });
        }
    }

    redirectTo(uri: string) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([uri])});
          this.draftsLookup(this.id);
      }

    draftsave() {
        let product_ids =  this.record.related_products;
    
        this.record = this.productForm.value;
        this.record.id = this.id;
        this.record.related_products = product_ids;
    
        if (this.id != 'new') {
            this.productService.draftsave(this.record)
            .subscribe(
                data => {
                    this.id = data.data.id;
                    this.record.id = data.data.id;
                    this.record = data.data;
                    this.draftProducts = data.data.draft_products;
                    this.redirectTo('/products/' + data.data.id);
                },
                error => {
                    this.handleError(error, this.productForm);
                });
        } else {
            this.productService.create(this.record)
            .subscribe(
                data => {
                    this.id = data.data.id;
                    this.record = data.data;
                    this.router.navigate(['/products/' + data.data.id]);
                },
                error => {
                    this.handleError(error, this.productForm);
                });
        }
    }
    

    deleteProduct(id: any): void{
        const isConfirmed = window.confirm('Are you sure you want to delete this draft product?');

        if (isConfirmed) {
            this.productService.draftdelete(id)
                .subscribe(
                    data => {
                        this.draftsLookup(this.id);
                    },
                    error => {
                        this.handleError(error, this.productForm);
                    }
                );
        }
    }

    PreviewProduct(id: any, fullpath:any): void{
        const previewUrl = `/preview/${id}/${fullpath}`;
        window.open(previewUrl, '_blank');
    }

    editProduct(currentid: number): void {
        this.id = currentid;
        this.record.id = currentid;
        this.draftsLookup(currentid);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/products/' + currentid]);
        });
      }

    nameChange() {
        if (this.id == 'new') {
            this.record.slug = this.string_to_slug(this.record.name);
        }
    }

    openPublishDialog(draftrecordId: any): void {
        const dialogRef = this.dialog.open(PublishDialogComponent, {
            width: '500px',
            data: { draftrecordId: draftrecordId, record: this.record }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const { selectedDate, selectedTime, publishNow, removeSchedule } = result;
      
            let product_ids =  this.record.related_products;
            this.record = this.productForm.value;
            this.record.id = this.id;
            this.record.related_products = product_ids;

            if (removeSchedule) {
              this.productService.removeSchedule(this.record)
                .subscribe(response => {
                  this.draftsLookup(this.id);
                  console.log('Schedule removed successfully:', response);
                }, error => {
                  console.error('Error removing schedule:', error);
                });
            } else if (publishNow) {

              this.productService.publishnow(this.record)
                .subscribe(response => {
                  this.draftsLookup(this.id);
                  console.log('Publish now successful:', response);
                }, error => {
                  this.handleError(error, this.productForm);
                });
            } else {
              this.productService.publishschedule(this.record, selectedDate, selectedTime)
                .subscribe(response => {
                    this.draftsLookup(this.id);
                    console.log('Publish scheduled successfully:', response);
                }, error => {
                  console.error('Error scheduling publish:', error);
                });
            }
          } else {
            console.log('Dialog closed without result');
          }
        });
      }

      convertToAEST(utcTime: string): string {
        const utcDate = new Date(utcTime);
        const aestDate = new Date(utcDate.getTime() + 10 * 60 * 60 * 1000);
        const aestDateString = this.formatDate(aestDate);
        return aestDateString;
      }
    
      formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = this.padNumber(date.getMonth() + 1);
        const day = this.padNumber(date.getDate());
        const hours = this.padNumber(date.getHours());
        const minutes = this.padNumber(date.getMinutes());
        const seconds = this.padNumber(date.getSeconds());
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    
      padNumber(num: number): string {
        return num < 10 ? '0' + num : num.toString();
      }
      
      
    
}
